import { useHistory } from "react-router-dom";

import ButtonBase from "@mui/material/ButtonBase"
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography"

import { MealNotesSelector, NutritionalTargetSelector, setSelectedMealType } from "../../../app/mealPlan/mealPlan.slice";
import { useAppDispatch, useAppSelector } from "../../../app/store/hooks";
import { AddeMeal, NoteIcon } from "../../../iconRef/mealPLanIcons";
import MealCard from "../mealCard/MealCard";
import MealIcon from "../MealIcon";
import { Meal, MealNote, Tramsformed_Meal } from "../mealPlan.types";
import { filterNotesByDate, getMealTime, getMissingMealTypes, getTotalCalories, getTotalNutritionalInfo, isDateInRange, isPastNextMeal, sortMealsByRecipeName, sortNotesByName, transformMeals } from "../utils";
import styles from './ScheduledMeals.module.css'
import ViewGroceryListCard from "../../../pages/mealPlan/ViewGroceryListCard";
import Grid2 from "@mui/material/Grid2";
import MealNoteCard from "../notesCard/NotesCard";
import NutritionalProgressContainer from "../nutritionalProgressContainer/NutritionalProgressContainer";
import { isCurrentOrPastDate } from "../Calendar/utils";
import AddNotesDrawer from "../addNotesDrawer/AddNotesDrawer";
import { useState } from "react";
import { UseGetFlag } from "../../../app/launchDarkly";
import { GroceryList } from "../../../app/commonSelector";

const mealTypes = ["Morning", "Afternoon", "Evening", "Night"];

const ScheduledMeal = ({ mealData, addMeal, refetchMeals, updateMealServingSize, refetchNotes }: { mealData: Tramsformed_Meal, addMeal: (mealType: string) => void, refetchMeals: () => Promise<void>, updateMealServingSize: (mealId: string, servingSize: number) => void, refetchNotes: () => Promise<void> }) => {
    if (!mealData || (mealData.meals.length === 0 && mealData.notes.length === 0)) {
        return null;
    }

    const mealTime = mealData?.meals && mealData?.meals[0]?.scheduled_date_time;
    const mealType = mealData?.meals && mealData?.meals[0]?.meal_type;

    const isPastMeal = mealTime ? isPastNextMeal(mealType, mealTime) : false;

    const totalCalories = getTotalCalories(mealData.meals, mealData.notes);
    const sortedMeals = sortMealsByRecipeName(mealData?.meals)
    const sortedNotes = sortNotesByName(mealData.notes);
    return (
        <Grid className={styles.scheduled_meal_container} >
            <Grid className={styles.scheduled_meal_details_container} >
                <Grid className={styles.scheduled_meal_details}>
                    <MealIcon height={52} mealType={mealData?.typeName} width={52} />
                    <Grid className={styles.scheduled_meal_details_text}>
                        <Typography variant="caption4Outfit">{mealData?.typeName}</Typography>
                        <Typography className={styles.meal_type_calories} component="p" variant="caloriesText">{totalCalories} kCal</Typography>

                    </Grid>
                </Grid>
                {!isPastMeal ? <ButtonBase className={styles.add_meal_meal_type} onClick={() => addMeal(mealData?.typeName)}>
                    <AddeMeal />
                    <Typography variant="caption4LightOutfit">Add</Typography>
                </ButtonBase> : null}
            </Grid>
            <Grid className={styles.meal_card_container}>
                {sortedNotes?.map((note: MealNote) => (
                    <MealNoteCard key={note.id} note={note} refetchNotes={refetchNotes} />
                ))}
                {sortedMeals?.map((meal: Meal) => (
                    <MealCard isPastMeal={isPastMeal} key={meal.id} meal={meal}
                        refetchMeals={refetchMeals} updateMealServingSize={updateMealServingSize} />

                ))}

            </Grid>
        </Grid>
    )
}

const ScheduledMeals = ({ meals, refetchMeals, selectedDate, updateMealServingSize, refetchNotes, refetchNutrionalTarget }: { meals: Meal[], refetchMeals: () => Promise<void>, selectedDate: Date, updateMealServingSize: (mealId: string, servingSize: number) => void, refetchNotes: () => Promise<void>, refetchNutrionalTarget: () => Promise<void> }) => {
    const mealNotes = useAppSelector(MealNotesSelector);
    const [showDrawer, setShowDrawer] = useState(false);
    const { enableMealPlanChallenge } = UseGetFlag();
    const filteredNotes = filterNotesByDate(selectedDate, mealNotes);
    const missingMealsTypes = getMissingMealTypes(mealTypes, meals, filteredNotes);
    const transformedMeals = transformMeals(mealTypes, meals, filteredNotes);
    const nutrionalTarget = useAppSelector(NutritionalTargetSelector);
    const nutritionalValues = getTotalNutritionalInfo(transformedMeals, nutrionalTarget?.nutritional_target);
    const history = useHistory();
    const dispatch = useAppDispatch();
    const currentDate = new Date();
    const currentDateWithoutTime = new Date(currentDate.setHours(0, 0, 0, 0));
    const pastDate = selectedDate < currentDateWithoutTime;
    const showNutritionalInfo = isCurrentOrPastDate(selectedDate)
    const groceryIngredientList = useAppSelector(GroceryList)

    const today = new Date();
    const todayDate = today.getDate();

    const sevenDaysLater = new Date(today);
    sevenDaysLater.setDate(today.getDate() + 7);
    const sevenDaysLaterDate = sevenDaysLater.getDate();

    const groceryListCondition = groceryIngredientList?.length && isDateInRange(selectedDate, today, sevenDaysLater);

    const addMeal = (mealType: string) => {
        dispatch(setSelectedMealType(mealType))
        history.push('meal-plan/add-meal')
    }

    const handleAddNoteButtonClick = () => {
        setShowDrawer(true)
    }

    return (
        <Grid className={styles.schedule_meals_container} >
            {enableMealPlanChallenge && showNutritionalInfo ? <Grid2>
                <NutritionalProgressContainer nutritionalValues={nutritionalValues} />
            </Grid2> : null}
            {groceryListCondition || enableMealPlanChallenge ? <Grid2 className={styles.gorcery_and_note_buttons_container}>
                {groceryListCondition? <ViewGroceryListCard />: null}
                {enableMealPlanChallenge ? <ButtonBase className={styles.add_note_button} onClick={handleAddNoteButtonClick}>
                    <NoteIcon />
                    <Grid2 className={styles.second_grid}>
                        <Typography variant='caption3Bold'>Add Note</Typography>
                    </Grid2>
                </ButtonBase> : null}
            </Grid2> : null}
            {missingMealsTypes.length > 0 ? <Grid className={`${styles.buttons_container} ${transformedMeals?.length ? styles.buttons_container_meal_present : ""} `}>
                {missingMealsTypes.map((missingMealsType) => {
                    const mealTime = getMealTime(missingMealsType, selectedDate);
                    const pastTime = mealTime < new Date();
                    return (!pastTime ? <ButtonBase className={`${styles.add_meal_button} ${transformedMeals?.length ? styles.add_meal_button_meal_present : ""}`} key={missingMealsType} onClick={() => addMeal(missingMealsType)}>
                        <AddeMeal />
                        <Typography variant="caption4LightOutfit">{missingMealsType}</Typography>
                    </ButtonBase>
                        : null)

                })}
            </Grid> : null}

            {transformedMeals ? transformedMeals.map((mealData: Tramsformed_Meal) => (
                <ScheduledMeal addMeal={addMeal} key={mealData.typeName} mealData={mealData}
                    refetchMeals={refetchMeals} updateMealServingSize={updateMealServingSize} refetchNotes={refetchNotes} />
            ))
                :
                null
            }
            {pastDate && !transformedMeals ?
                <Grid className={styles.no_meals}>
                    <Typography variant="caption4Light">No meals scheduled</Typography>
                </Grid> : null
            }
            {enableMealPlanChallenge ? <AddNotesDrawer drawer={showDrawer} setDrawer={setShowDrawer} refetchNotes={refetchNotes} /> : null}

        </Grid>
    )
}

export default ScheduledMeals
